import script from "./ViewAllUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllUsers.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllUsers.vue?vue&type=style&index=0&id=463a52f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-463a52f1"]])

export default __exports__